import * as z from "zod";

export const getReplenishmentRequestViewCounts = {
  name: "getReplenishmentRequestViewCounts" as const,
  input: z.null(),
  output: z.object({
    viewCounts: z.record(z.string(), z.number()),
    folderCounts: z.record(z.string(), z.number()),
  }),
};
